import ICRSService from './icrs-service';

export default ICRSService;
